import React from 'react';
import { Container } from 'reactstrap';
// import { HashLink as Link } from 'react-router-hash-link';
// import ellipseImageTop from '../../assets/images/landingpage/Ellipse1880.avif'
// import ellipseImageBottom from '../../assets/images/landingpage/Ellipse1879.avif'
import { NextArrowCircle } from '../../common/icons';
import { Link } from 'react-router-dom';
import * as Icons from '../../common/icons/homePageIcons';

const WeAreVarahiSoft = ({ varahiSoftData }) => {
    const weAreVarahiSoftData = varahiSoftData;
    return (
        <section className='wearevarahiSoft-section'>
            <div className="acss-1kbtli">
                <div className='position-absolute' style={{ inset: 0 }}>
                    <div className="acss-lbif7z acss-b61x89">
                        <img rel="preload" className="acss-61n50j acss-118odl4" src={'/assets/images/landingpage/Ellipse1880.avif'} alt="ellipseImage" />
                        <img rel="preload" className="acss-61n50j acss-x14t9p" src={'/assets/images/landingpage/Ellipse1879.avif'} alt="img" />
                    </div>
                    <div className="acss-lbif7z acss-wom5xg">
                        <img rel="preload" className="acss-61n50j acss-1ptcy1b" src={'/assets/images/landingpage/Ellipse1880.avif'} alt="img" />
                        <img rel="preload" className="acss-61n50j acss-1ht8015" src={'/assets/images/landingpage/Ellipse1879.avif'} alt="img" />
                    </div>
                    <div></div>
                </div>
                <Container className='acss-18azjcp' style={{ paddingBlock: '80px' }} >
                    <div className="justify-content-start">
                        <div className="align-self-start">
                            <h2>{weAreVarahiSoftData?.title}</h2>
                            <span>{weAreVarahiSoftData?.text}</span>
                        </div>
                    </div>
                    <div className='custom-pending-top'>
                        <div className='d-flex flex-wrap justify-content-start align-self-start gap-5'>
                            <div className='w-64'>
                                <div className='my-background'>
                                    <img rel="preload" className='w-100' src={weAreVarahiSoftData?.alignedWithYourBusiness?.bgImg} alt='myImg' />
                                    <div className='product'>
                                        <h3>{weAreVarahiSoftData?.alignedWithYourBusiness?.title}</h3>
                                        <span className='para'>{weAreVarahiSoftData?.alignedWithYourBusiness?.text}</span>
                                    </div>
                                </div>
                            </div>
                            {weAreVarahiSoftData?.technologies?.map((tech, index) => {
                                const Icon = Icons[tech?.icon] || null;
                                return (
                                    <Link className='Product-Engineering' key={index} to={`${tech?.link}`} >
                                        <div className='product-inner d-flex flex-column gap-4'>
                                            {Icon && <Icon />}
                                            <div>
                                                <h3>{tech?.title}</h3>
                                                <span>{tech?.text}</span>
                                            </div>
                                        </div>
                                    </Link>
                                )
                            })}
                            <div className='Product-Engineering d-flex justify-content-center align-items-center'>
                                <Link to={'/services'} aria-label="View Services" className='product-inner nextArrowLst d-flex justify-content-center align-items-center'>
                                    <div className='next-arrow justify-content-center align-self-center'>
                                        <NextArrowCircle />
                                    </div>
                                    {/* <div className='hover-arrow justify-content-center align-self-center'>
                                        <HoverNextArrowCircle />
                                    </div> */}
                                </Link>
                            </div>
                        </div>
                    </div>
                </Container>
            </div>
        </section>
    );
}

export default WeAreVarahiSoft;
